import {RxStompConfig} from '@stomp/rx-stomp';
import {environment} from '../../../environments/environment';

export function createSuiteRxStompConfig(username: string | null, token: string | null): RxStompConfig {
  return {
    brokerURL: environment.WS_URL_SUITE,
    connectHeaders: {
      login: `${username}`,
      passcode: `${token}`
    },
    heartbeatIncoming: 0,
    heartbeatOutgoing: 20000,
    reconnectDelay: 500,
    debug: (msg: string): void => {
      console.log(new Date(), 'SUITE', msg);
    }
  };
};
